module.exports = __webpack_public_path__ + "img/vrar.6218ec07.png";